import find from 'lodash/find';
import isEmpty from 'lodash/isEmpty';
import keyBy from 'lodash/keyBy';
import mapValues from 'lodash/mapValues';

/**
 * Applies arguments ({0}, {1}, etc) to a string.
 * @param label
 * @param args
 * @return {*}
 */
const applyArguments = (label, args) => {
  if (!label || !args || !args.length) {
    return label;
  }

  args.forEach((value, index) => {
    label = label.replace(`{${index}}`, value);
  });
  return label;
};

export default {
  props: {
    baseProperties: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    baseProps() {
      if(!this.baseProperties || !this.baseProperties.length) return {};
      const obj = keyBy(this.baseProperties, 'name');
      return mapValues(obj, val => val.label);
    }
  },

  methods: {
    bp(name, ...args) {
      if (isEmpty(this.baseProps)) {
        return null;
      }

      return name in this.baseProps ? applyArguments(this.baseProps[name], args) : '';
    },

    getBaseProperty(name, ...args) {
      if (!this.baseProperties || !this.baseProperties.length) {
        return null;
      }

      const baseProperty = find(this.baseProperties, (baseProperty) => baseProperty.name === name);
      return baseProperty ? applyArguments(baseProperty.label, args) : '';
    },
  },
};
